var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.styles.dates},_vm._l((_vm.dates),function(date){return _c('div',{key:date.unix,class:_vm.getClasses(date),on:{"click":function($event){return _vm.$emit('select', date)},"mouseover":function($event){return _vm.$emit('hover', date)}}},[_vm._v(_vm._s(date.date))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }